/**
 * New-booking webhook (Make.com) — shared by the new-booking wizard and quick
 * booking so both send the same payload rules.
 */

// Booking webhook endpoint (generates token + forwards to Make.com)
export const BOOKING_WEBHOOK_URL = '/api/booking-webhook';

/**
 * Determine if the booking start date is past the cutoff for sending codes.
 * Priority: time_cut_off (rolling hours) > cut_off_codes + days_cut_off (fixed daily) > default true
 */
export function isPastCutoff(location: any, startDateISO: string): boolean {
  const now = new Date();
  const startDate = new Date(startDateISO);

  // 1. Rolling cutoff: time_cut_off hours before booking start
  const timeCutOff = parseFloat(location.time_cut_off);
  if (!isNaN(timeCutOff) && timeCutOff > 0) {
    const cutoffTime = new Date(startDate.getTime() - timeCutOff * 60 * 60 * 1000);
    return now >= cutoffTime;
  }

  // 2. Fixed daily cutoff: (start_date - days_cut_off days) at cut_off_codes time
  const daysCutOff = Number(location.days_cut_off);
  const cutOffCodes = location.cut_off_codes; // e.g. "14:00"
  if (!isNaN(daysCutOff) && daysCutOff >= 0 && cutOffCodes) {
    const cutoffDate = new Date(startDate);
    cutoffDate.setDate(cutoffDate.getDate() - daysCutOff);
    const [hours, minutes] = cutOffCodes.split(':').map(Number);
    cutoffDate.setHours(hours, minutes, 0, 0);
    return now >= cutoffDate;
  }

  // 3. Neither configured: default to past cutoff (send immediately)
  return true;
}

/**
 * Determine the send_now value for the Make.com webhook.
 * - two_emails_enabled = false → always send_now (single email flow)
 * - two_emails_enabled = true → send_now only if past cutoff
 */
export function determineSendNow(location: any, startDateISO: string): boolean {
  if (!location.two_emails_enabled) {
    return true;
  }
  return isPastCutoff(location, startDateISO);
}
